export default function authentication({ app, store, query }) {
  const token = localStorage.token
  if (token) {
    if (store.getters['credential/isAuthenticated']) return
    store.dispatch('credential/setToken', token)
  } else if (!query.auth) {
    window.location.replace('https://loja.mege.com.br/')
  }
  if (query.auth) {
    store.dispatch('credential/setToken', query.auth)
    // store.$router.push('/class')
  }
  if (!store.getters['credential/isAuthenticated']) return
  app.$axios.setToken(store.state.credential.token, 'Bearer')
}
